import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommonCommunicationService } from '../services/commonCommunication.service';
declare global {
    namespace HttpHeaders {
        interface headers {
            auth?: any;
        }
    }
}
@Injectable()
export class JwtInterceptor implements HttpInterceptor {

    constructor(private ccs: CommonCommunicationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (!request.headers.has('noauth')) {
            let token = this.ccs.getJwtToken()
            let userId:any=JSON.parse(localStorage.getItem('user-id')||'{}')
            if (token) {
                request = request.clone({
                    setHeaders: {
                        "x-access-token": `${token}`,
                        "user-id":`${userId}`
                    }
                });
            }
        }

        return next.handle(request);
    }
}